export default __webpack_public_path__ + "static/media/slide-3.87ff0e2b.png";